import React, { useState, useEffect } from 'react'
import './userlogin.scss'
import { useHistory } from 'react-router-dom'
import API_CONSTANTS from '../api-constants'

const Login = ({orgID }) => {
   
    let key = sessionStorage.getItem('key')
    const stored_email = localStorage.getItem('email')
    const stored_pw = localStorage.getItem('pw')
    const history = useHistory();
    const [loading, setLoading] = useState(false)
    const [resetPassword, setResetPassword] = useState(false)
    const [error, setError] = useState(false)
    const [notFoundError,setNotFoundError] = useState()
    const [emailError, setEmailError] = useState('')
    const [email, setEmail] = useState(stored_email ? stored_email : '')
    const [password, setPassword] = useState(stored_pw ? stored_pw :'');
    const [passwordError, setPasswordError] = useState("");
    const [rememberme, setRememberme] = useState(stored_email && stored_pw ? true : false)
   
    const [showNoValidEmail, setShowNoValidEmail] = useState()
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
   

    const validateEmail = (e) => { 
        if (e.target?.value && e.target.value.match(isValidEmail)) {
            setShowNoValidEmail(false);
            setEmail(e.target.value)
        }       
    }

    function encodeBase64(str) {
        return window.btoa(new TextEncoder().encode(str).reduce((data, byte) => data + String.fromCharCode(byte), ""));
    }

  function handleSubmit  ()  {
     
        if (email === '' ||password === '') {
            setError(true)
        }
        if (email === '') {
            setEmailError('Udfyld venligst email')
        }
        if (password === '') {
            setPasswordError('Udfyld venligst adgangskode')
        }
        
        if (email && email.length && email.match(isValidEmail) && password.length) {
            let encoded_password = encodeBase64(password)

            setLoading(true)
            // if email and password is correct and founds in the system - go to profile page
            fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/Login?Email=${email}&Password=${encoded_password}`, {
                method: "GET",
                headers: {
                    'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                    'Content-Type': 'application/x-www-form-urlencoded',
                },  
            })
                .then((res) => res.json())
                .then(result => {
                    setLoading(false)
               
                    if (result.result === 1) {
                        sessionStorage.setItem('login_info', JSON.stringify([result.login]))
                        sessionStorage.setItem('login_pw', password)
                        sessionStorage.setItem('key', result.key)
                        
                       
                       
                        history.push(`/profile?org=${orgID}`, {
                            login_info: result.login,
                            transaction: result.transactionsPrYear[0],
                            newsgroup: result.Newsgroups,
                            reservations: result.Reservations,
                            memberships: result.Memberships,
                            orgID: orgID,
                            vouchers: result.Vouchers

                        })

                    }
                    else {
                        setError(true)
                        setEmailError(result.Message)
                    }
                })


         
        }
        else if (email.length && !email.match(isValidEmail)) {
           
            setShowNoValidEmail(true);
            setEmailError('Email er ikke gyldig')
            setError(true)
        }
    };

    const emailChanged = (e) => {
     
        setEmail(e.target.value)
        setEmailError('')
        validateEmail(e)
        setError(false)
    }
    const passwordChanged = (e) => {
        setPassword(e.target.value)
        setPasswordError('')
        setError(false)
        
    }

    function handleRememberChange() {
        setRememberme((current => !current))
      
    }

    function passwordForgotten() {
        history.push('/resetpassword')
       
    }

   


    function handleCreateProfile() {
        history.push('/createaccount')
    }

    useEffect(() => {
       
        if (rememberme === true) {
            localStorage.setItem('email', email)
            localStorage.setItem('pw', password)

        }
        else if (rememberme === false) {  
            localStorage.removeItem('email', email)
            localStorage.removeItem('pw', password)
        }
    }, [rememberme, password, email])

    

    return (
        <>
           
            {loading === true ? <div className='spinner' style={{ borderRightColor: 'rgba(157, 45, 38, 1)',marginTop:'20%' }}></div>
                :  
                key ?
                    history.push(`/profile?org=${orgID}`)
                    :

                    <div className='loginflow'  >
                        <p className='profile' style={{ color: orgID == 0 ? '#f1c895' : '' }}>Login</p>
                 <p className='emailtext'>Indtast brugeroplysninger</p>
           
                <label className='email-label'>Email</label>
                <input className='email-input' placeholder='Indtast email' value={email} onChange={(e) => emailChanged(e)} />
                <label>Adgangskode</label>
                    <input className='password-input' type='password' value={password} placeholder='Indtast adgangskode' onChange={(e) => passwordChanged(e)} ></input>
                    <div  style={{ display: 'flex', justifyContent: 'space-between' }}>
                         <div className='rememberMeContainer' style={{ position: 'relative' }} /*onClick={() => handleRememberChange() }*/>
                                                     
                           <input style={{ width: '20px', height: '20px', marginRight: '10px', borderRadius: '3px' }} type="checkbox" checked={rememberme}
                                onChange={handleRememberChange} />
                           <label style={{ position: 'absolute', left: '35px', width:'100px',fontWeight:400, bottom:'12px' }}>Husk mig</label>
                         </div>
                    
                        <button type="submit" className='login-btn' onClick={ handleSubmit}>Log ind</button>                                      
                     </div>
                <div className='btns-container' >
                        <button onClick={passwordForgotten }>Glemt adgangskode?</button>
                       <button  onClick={handleCreateProfile }>Opret profil</button>
                </div>
           
            {error === true ?
                <div className='error-div'>
                    {notFoundError}
                    {emailError && <span>{emailError}</span>}
                    {passwordError && <span>{passwordError}</span>}
                </div> : null}
            </div>
                    
            } 
            
        </>
    )
}

export default Login